import { List, Plus, Trash2 } from "lucide-react";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useHasFirstUserMessage } from "@noa/client-store";
import { Button, Title } from "~/components/ui";

interface ConversationHistoryListHeaderProps {
  showDeleted: boolean;
  setShowDeleted: (value: boolean) => void;
}

export const ConversationHistoryListHeader: FunctionComponent<ConversationHistoryListHeaderProps> = ({
  showDeleted,
  setShowDeleted,
}) => {
  const { t } = useTranslation();

  const hasFirstUserMessage = useHasFirstUserMessage();

  return (
    <div className="mb-4 flex items-center justify-between">
      <Title level={5} className="m-0">
        {t(showDeleted ? "conversation:deletedTitle" : "conversation:title")}
      </Title>

      <div className="flex gap-1">
        <Button
          title={t(showDeleted ? "conversation:showActive" : "conversation:showDeleted")}
          variant="text"
          icon={showDeleted ? <List size={14} /> : <Trash2 size={14} />}
          onClick={() => setShowDeleted(!showDeleted)}
          className="active:bg-transparent!"
        />
        {!showDeleted &&
          (hasFirstUserMessage ? (
            <Link
              to="/"
              title={t("conversation:newConversation")}
              className="flex items-center justify-center size-8 rounded-md text-noa-muted hover:bg-noa-inset"
            >
              <Plus size={14} />
            </Link>
          ) : (
            <span className="flex items-center justify-center size-8 text-noa-muted opacity-40">
              <Plus size={14} />
            </span>
          ))}
      </div>
    </div>
  );
};
